<div
  class="progress-container"
  role="progressbar"
  [attr.aria-valuenow]="scrollProgress"
  aria-valuemin="0"
  aria-valuemax="100"
>
  <div class="progress-bar" [style.width.%]="scrollProgress"></div>
</div>
